var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4795 16.6768C14.4795 15.0199 15.8226 13.6768 17.4795 13.6768H28.8362C30.493 13.6768 31.8362 15.0199 31.8362 16.6768V33.6124C31.8362 35.2693 30.493 36.6124 28.8362 36.6124H17.4795C15.8226 36.6124 14.4795 35.2693 14.4795 33.6124V16.6768Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4795 11.8174H31.0033L31.8362 16.7764H14.4795H14.3439V16.7728C13.0376 16.7024 12 15.6208 12 14.2969C12 12.973 13.0376 11.8914 14.3439 11.821V11.8174H14.4795Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0033 11.8174L31.9895 11.6517C31.9086 11.1701 31.4916 10.8174 31.0033 10.8174V11.8174ZM31.8362 16.7764V17.7764C32.1304 17.7764 32.4097 17.6469 32.5997 17.4223C32.7897 17.1978 32.8711 16.9009 32.8224 16.6108L31.8362 16.7764ZM14.3439 16.7764H13.3439C13.3439 17.3287 13.7916 17.7764 14.3439 17.7764V16.7764ZM14.3439 16.7728H15.3439C15.3439 16.2414 14.9283 15.8028 14.3977 15.7742L14.3439 16.7728ZM14.3439 11.821L14.3977 12.8196C14.9283 12.791 15.3439 12.3524 15.3439 11.821H14.3439ZM14.3439 11.8174V10.8174C13.7916 10.8174 13.3439 11.2651 13.3439 11.8174H14.3439ZM14.4795 12.8174H31.0033V10.8174H14.4795V12.8174ZM30.0171 11.983L30.85 16.9421L32.8224 16.6108L31.9895 11.6517L30.0171 11.983ZM31.8362 15.7764H14.4795V17.7764H31.8362V15.7764ZM14.4795 15.7764H14.3439V17.7764H14.4795V15.7764ZM15.3439 16.7764V16.7728H13.3439V16.7764H15.3439ZM14.3977 15.7742C13.6191 15.7323 13 15.0866 13 14.2969H11C11 16.1551 12.456 17.6725 14.2901 17.7713L14.3977 15.7742ZM13 14.2969C13 13.5073 13.6191 12.8615 14.3977 12.8196L14.2901 10.8225C12.456 10.9213 11 12.4387 11 14.2969H13ZM15.3439 11.821V11.8174H13.3439V11.821H15.3439ZM14.3439 12.8174H14.4795V10.8174H14.3439V12.8174Z",
    fill: "#F1BF70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0033 14.2969H12.6117C12.6044 14.3604 12.6006 14.4251 12.6006 14.4906C12.6006 15.4107 13.3464 16.1565 14.2665 16.1565H31.0033V14.2969Z",
    fill: "#F9E5C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3158 14.0994C34.3158 12.3877 32.9281 11 31.2164 11C29.5046 11 28.1169 12.3877 28.1169 14.0994C28.1169 15.8112 29.5046 17.1988 31.2164 17.1988V33.5131L34.3158 31.6534V14.0994Z",
    fill: "#F1BF70"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5966,
    cy: 32.2731,
    r: 6.72669,
    fill: "white",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5965,
    cy: 32.273,
    r: 3.71929,
    fill: "#F1BF70",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9929 31.9018L29.4806 34.1334L33.1999 30.4141",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5789,
    y: 20.4956,
    width: 10.538,
    height: 1.23976,
    fill: "#F1BF70"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5789,
    y: 24.2148,
    width: 10.538,
    height: 1.23976,
    fill: "#F1BF70"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5789,
    y: 27.9341,
    width: 8.05847,
    height: 1.23976,
    fill: "#F1BF70"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5789,
    y: 31.6533,
    width: 6.72669,
    height: 1.23976,
    fill: "#F1BF70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.712d35cf4af88ac6ba038cb32b7a26bf.svg";
export { ForwardRef as ReactComponent };